export const GET_SITE_BY_ID_REQUEST = 'GET_SITE_BY_ID_REQUEST'
export const GET_SITE_BY_ID_SUCCESS = 'GET_SITE_BY_ID_SUCCESS'
export const GET_GS_REQUESTS_FAILURE = 'GET_GS_REQUESTS_FAILURE'

//heco_sdp

export const SET_CURRENT_SITE_ID = 'SET_CURRENT_SITE_ID'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
